import { Box } from '@material-ui/core';

import { ProgressBarAndTimeline } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/ProgressBarAndTimeline';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';
import { Conditions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/ConditionsAndProgress/Conditions/Conditions';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

interface ConditionsAndProgressProps {
  paymentMethodDetailEntity: SinglePaymentMethodDetailEntity;
}

export const ConditionsAndProgress = ({ paymentMethodDetailEntity }: ConditionsAndProgressProps) => {
  return (
    <CustomPaper fill="paper" style={{ paddingBottom: 16 }}>
      <Conditions paymentMethodDetailEntity={paymentMethodDetailEntity} />
      <Box mt={3} />
      <ProgressBarAndTimeline paymentMethodDetailEntity={paymentMethodDetailEntity} />
    </CustomPaper>
  );
};
